import { Field, Textarea as ChakraTextarea } from "@chakra-ui/react"
import { forwardRef } from "react"
import { getThemeColor } from "theme/colors"

interface TextareaProps extends React.ComponentProps<typeof ChakraTextarea> {
  label?: string
  helperText?: string
  errorText?: string
  required?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, helperText, errorText, required, ...props }, ref) => {
    const textareaStyles = {
      bg: getThemeColor('textarea.bg'),
      borderColor: getThemeColor('textarea.border'),
      color: getThemeColor('textarea.text'),
      _placeholder: {
        color: getThemeColor('textarea.placeholder'),
      },
      _focus: {
        borderColor: getThemeColor('textarea.borderFocus'),
        boxShadow: `0 0 0 1px ${getThemeColor('textarea.borderFocus').base}`,
        _dark: {
          boxShadow: `0 0 0 1px ${getThemeColor('textarea.borderFocus')._dark}`,
        },
      },
      ...props,
    };

    if (label || helperText || errorText) {
      return (
        <Field.Root invalid={!!errorText} required={required}>
          {label && <Field.Label>{label}</Field.Label>}
          <ChakraTextarea ref={ref} {...textareaStyles} />
          {helperText && <Field.HelperText>{helperText}</Field.HelperText>}
          {errorText && <Field.ErrorText>{errorText}</Field.ErrorText>}
        </Field.Root>
      )
    }
    
    return <ChakraTextarea ref={ref} {...textareaStyles} />
  }
)

Textarea.displayName = "Textarea"
